import Vue from 'vue'
// import { i18n } from '@/i18n'

const state = {
  baseUri: '/botw/config/spot/'
}
const getters = {
}
const actions = {
  codes: function (_context, [data, callback]) { // 지자체 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'codes',
      params: data
    }
    console.log('actions codes axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  search: function (_context, [searchParam, callback]) { // 현장관리 리스트 조회
    const reqData = {
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount,
      dongName: searchParam.dongName,
      spotSeq: searchParam.spotSeq,
      spotGubun: searchParam.spotGubun
      // hnFlag: String(searchParam.hnFlag),
      // duruFlag: String(searchParam.duruFlag)
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'search',
      params: reqData
    }
    console.log('actions search axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  searchDong: function (_context, [data, callback]) { // 법정동 조회
    const reqData = {
      level: data.level,
      upperDongCode: data.dongCode
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'dongSearch',
      params: reqData
    }
    console.log('actions dongSearch axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  detail: function (_context, [spotSeq, callback]) { // 현장 상세 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'detail/' + spotSeq
      // params: spotSeq
    }
    console.log('actions detail axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  gimsSearch: function (_context, [searchParam, callback]) { // gims코드 목록조회
    const reqData = {
      spotName: searchParam.spotName,
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'gimsSearch',
      params: reqData
    }
    console.log('actions gimsSearch axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  contractCompSearch: function (_context, [searchParam, callback]) { // 계약업체 목록조회
    const reqData = {
      contractCompName: searchParam.contractCompName,
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'contractCompSearch',
      params: reqData
    }
    console.log('actions contractCompSearch axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  consignCompSearch: function (_context, [searchParam, callback]) { // 위탁업체 목록조회
    const reqData = {
      consignCompName: searchParam.consignCompName,
      // dongName: searchParam.dongName,
      extraAddress: searchParam.dongName,
      hnDuruGubun: '정보통신',
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'consignCompSearch',
      params: reqData
    }
    console.log('actions consignCompSearch axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  insert: function (_context, [param, callback]) { // 등록
    let reqData = {}
    if (param.spotGubun.indexOf('홈네트워크') >= 0 && param.spotGubun.indexOf('정보통신') >= 0) {
      reqData = {
        spotSeq: param.spotSeq, // gims 현장으로만 가능하게끔 바뀜으로서 추가
        address: param.address,
        dongCode: param.dongCode,
        spotName: param.spotName,
        houseHoldNum: param.houseHoldNum,
        laeCodeId: param.laeCodeId,
        spotGubun: '홈네트워크,정보통신',
        checkRange: param.checkRange,
        contractCompSeq: Number(param.contractCompSeq),
        fileCode: param.tbFile.fileCode,
        trustCheckFlag: String(param.trustCheckFlag),
        consignCompSeq: param.consignCompSeq,
        note: param.note,
        officePhoneNum: param.officePhoneNum
      }
    } else if (param.spotGubun.indexOf('홈네트워크') >= 0 && param.spotGubun.indexOf('정보통신') < 0) {
      reqData = {
        spotSeq: param.spotSeq, // gims 현장으로만 가능하게끔 바뀜으로서 추가
        address: param.address,
        dongCode: param.dongCode,
        spotName: param.spotName,
        houseHoldNum: param.houseHoldNum,
        laeCodeId: '',
        spotGubun: '홈네트워크',
        checkRange: param.checkRange,
        contractCompSeq: Number(param.contractCompSeq),
        fileCode: param.tbFile.fileCode,
        trustCheckFlag: String(param.trustCheckFlag),
        consignCompSeq: param.consignCompSeq,
        note: param.note,
        officePhoneNum: param.officePhoneNum
      }
    } else if (param.spotGubun.indexOf('홈네트워크') < 0 && param.spotGubun.indexOf('정보통신') >= 0) {
      reqData = {
        address: param.address,
        dongCode: param.dongCode,
        spotName: param.spotName,
        houseHoldNum: param.houseHoldNum,
        laeCodeId: param.laeCodeId,
        spotGubun: '정보통신',
        checkRange: param.checkRange,
        contractCompSeq: Number(param.contractCompSeq),
        fileCode: param.tbFile.fileCode,
        trustCheckFlag: String(param.trustCheckFlag),
        consignCompSeq: param.consignCompSeq,
        note: param.note,
        officePhoneNum: param.officePhoneNum
      }
    }

    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'insert',
      data: reqData
    }
    console.log('actions insert axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  update: function (_context, [param, callback]) { // 수정
    let reqData = {}
    if (param.spotGubun.indexOf('홈네트워크') >= 0 && param.spotGubun.indexOf('정보통신') >= 0) {
      reqData = {
        spotSeq: param.spotSeq,
        spotName: param.spotName,
        spotGubun: param.spotGubun,
        houseHoldNum: param.houseHoldNum,
        trustCheckFlag: String(param.trustCheckFlag),
        consignCompSeq: param.consignCompSeq,
        note: param.note,
        spotType: param.spotType,
        pmName: param.pmName,
        modelName: param.modelName,
        laeCodeId: param.laeCodeId,
        contractCompSeq: Number(param.contractCompSeq),
        checkRange: param.checkRange,
        fileCode: param.tbFile.fileCode,
        address: param.address,
        officePhoneNum: param.officePhoneNum,
        dongCode: param.dongCode
      }
    } else if (param.spotGubun.indexOf('홈네트워크') >= 0 && param.spotGubun.indexOf('정보통신') < 0) {
      reqData = {
        spotSeq: param.spotSeq,
        spotName: param.spotName,
        spotGubun: param.spotGubun,
        houseHoldNum: param.houseHoldNum,
        trustCheckFlag: String(param.trustCheckFlag),
        consignCompSeq: param.consignCompSeq,
        note: param.note,
        spotType: param.spotType,
        pmName: param.pmName,
        modelName: param.modelName,
        laeCodeId: '',
        contractCompSeq: Number(param.contractCompSeq),
        checkRange: param.checkRange,
        fileCode: param.tbFile.fileCode,
        address: param.address,
        officePhoneNum: param.officePhoneNum,
        dongCode: param.dongCode
      }
    } else if (param.spotGubun.indexOf('홈네트워크') < 0 && param.spotGubun.indexOf('정보통신') >= 0) {
      reqData = {
        spotSeq: param.spotSeq,
        spotName: param.spotName,
        spotGubun: param.spotGubun,
        houseHoldNum: param.houseHoldNum,
        trustCheckFlag: String(param.trustCheckFlag),
        consignCompSeq: param.consignCompSeq,
        note: param.note,
        spotType: param.spotType,
        pmName: param.pmName,
        modelName: param.modelName,
        laeCodeId: param.laeCodeId,
        contractCompSeq: Number(param.contractCompSeq),
        checkRange: param.checkRange,
        fileCode: param.tbFile.fileCode,
        address: param.address,
        officePhoneNum: param.officePhoneNum,
        dongCode: param.dongCode
      }
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'update',
      data: reqData
    }
    console.log('actions update axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  descInsert: function (_context, [param, callback]) { // 특이사항 등록
    const reqData = {
      // insertUserSeq: param.insertUserSeq,
      spotSeq: param.spotSeq,
      desc: param.desc
    }

    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'descInsert',
      data: reqData
    }
    console.log('actions descInsert axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  descUpdate: function (_context, [param, callback]) { // 특이사항 수정
    const reqData = {
      updateUserSeq: param.updateUserSeq,
      spotDtlSeq: param.spotDtlSeq,
      spotSeq: param.spotSeq,
      desc: param.desc
    }

    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'descUpdate',
      data: reqData
    }
    console.log('actions descUpdate axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  descDelete: function (_context, [param, callback]) { // 특이사항 삭제
    const reqData = {
      spotSeq: param.spotSeq,
      spotDtlSeq: param.spotDtlSeq
    }

    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'descDelete',
      data: reqData
    }
    console.log('actions descDelete axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  delete: function (_context, [param, callback]) { // 미사용 처리
    const reqData = {
      spotSeq: param.spotSeq
      // spotGubun: param.spotGubun
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'delete',
      data: reqData
    }
    console.log('actions delete axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  fileCodeUpdate: function (_context, [data, callback]) {
    console.log('fileCodeUpdate : ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'fileCodeUpdate',
      data: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  fileCodeInit: function (_context, [data, callback]) {
    console.log('fileCodeInit actions : ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'fileCodeInit',
      data: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
